import { useMutation } from '@tanstack/react-query';
import { toast } from '@huspy/forge/shared';
import { trackAmplitudeEvent } from '@shared/analytics/amplitude';
import { USER_EVENTS } from '@shared/analytics/events';
import queryClient from '@app/queryClient';
import { referAndEarnApi } from '..';

const useCreateLead = () => {
  const {
    error, mutate, isPending, mutateAsync, isSuccess, reset,
  } = useMutation({
    mutationKey: ['referLead'],
    mutationFn: (body: any) =>
      referAndEarnApi.createLead(body),
    onMutate: () => {
      trackAmplitudeEvent(USER_EVENTS.REFER_AND_EARN.ATTEMPTED);
    },
    onSuccess: () => {
      trackAmplitudeEvent(USER_EVENTS.REFER_AND_EARN.COMPLETED);
      queryClient.invalidateQueries({ queryKey: ['referredLeadsList'] });
    },
    onError: (e) => {
      trackAmplitudeEvent(USER_EVENTS.REFER_AND_EARN.FAILED, { useContext: true, error_message: e.message });
      toast('error', { message: e.message, duration: 5000 });
    },
  });

  return {
    mutate, error, isPending, mutateAsync, isSuccess, reset,
  };
};

export default useCreateLead;
